var React = require('react');

function Headway (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.9546 18.684C8.77946 18.684 5.60428 18.684 2.4253 18.684C2.25575 18.7024 2.08522 18.6605 1.9411 18.565C1.79698 18.4696 1.68762 18.3262 1.63056 18.1578C0.869378 16.5828 0.443582 14.8533 0.382621 13.0888C0.321661 11.3243 0.626985 9.56704 1.27748 7.93841C1.92798 6.30977 2.90814 4.84865 4.15019 3.65605C5.39224 2.46346 6.86655 1.56784 8.4712 1.03112C10.0758 0.494402 11.7726 0.32939 13.444 0.547483C15.1155 0.765576 16.7218 1.36157 18.152 2.29427C19.5821 3.22698 20.802 4.47413 21.7272 5.94952C22.6525 7.4249 23.261 9.09332 23.5108 10.8394C23.8788 13.3976 23.4409 16.0117 22.2635 18.2854C22.214 18.4165 22.1245 18.5268 22.0089 18.5989C21.8933 18.671 21.7582 18.7009 21.6247 18.684C18.4001 18.6681 15.1767 18.6681 11.9546 18.684Z","fill":"#47B677"}));
}

Headway.defaultProps = {"width":"24","height":"19","viewBox":"0 0 24 19","fill":"none"};

module.exports = Headway;

Headway.default = Headway;
